import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6996f3db = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _687c1504 = () => interopDefault(import('../pages/bindAccount.vue' /* webpackChunkName: "pages/bindAccount" */))
const _3eb96730 = () => interopDefault(import('../pages/consent.vue' /* webpackChunkName: "pages/consent" */))
const _7061f04a = () => interopDefault(import('../pages/coupons.vue' /* webpackChunkName: "pages/coupons" */))
const _44a0aa7f = () => interopDefault(import('../pages/game-ids.vue' /* webpackChunkName: "pages/game-ids" */))
const _ed6262c0 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _bc9e388c = () => interopDefault(import('../pages/me.vue' /* webpackChunkName: "pages/me" */))
const _bb683376 = () => interopDefault(import('../pages/mp.vue' /* webpackChunkName: "pages/mp" */))
const _636d509f = () => interopDefault(import('../pages/order/index.vue' /* webpackChunkName: "pages/order/index" */))
const _304b10f6 = () => interopDefault(import('../pages/pay.vue' /* webpackChunkName: "pages/pay" */))
const _62203521 = () => interopDefault(import('../pages/procedure.vue' /* webpackChunkName: "pages/procedure" */))
const _586d8f9e = () => interopDefault(import('../pages/setting.vue' /* webpackChunkName: "pages/setting" */))
const _423b6400 = () => interopDefault(import('../pages/takings/index.vue' /* webpackChunkName: "pages/takings/index" */))
const _9865cefa = () => interopDefault(import('../pages/wx.vue' /* webpackChunkName: "pages/wx" */))
const _16d6dfc0 = () => interopDefault(import('../pages/auth/binding.vue' /* webpackChunkName: "pages/auth/binding" */))
const _6ae2d2b8 = () => interopDefault(import('../pages/auth/forgot.vue' /* webpackChunkName: "pages/auth/forgot" */))
const _2e7dfb16 = () => interopDefault(import('../pages/auth/help.vue' /* webpackChunkName: "pages/auth/help" */))
const _1fda0938 = () => interopDefault(import('../pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _1246fa20 = () => interopDefault(import('../pages/auth/password.vue' /* webpackChunkName: "pages/auth/password" */))
const _6f45b2f8 = () => interopDefault(import('../pages/auth/register.vue' /* webpackChunkName: "pages/auth/register" */))
const _024f8582 = () => interopDefault(import('../pages/oauth/authorize.vue' /* webpackChunkName: "pages/oauth/authorize" */))
const _58ed563a = () => interopDefault(import('../pages/order/cart.vue' /* webpackChunkName: "pages/order/cart" */))
const _9701d2ee = () => interopDefault(import('../pages/order/checkout.vue' /* webpackChunkName: "pages/order/checkout" */))
const _40c3ae4d = () => interopDefault(import('../pages/order/confirm.vue' /* webpackChunkName: "pages/order/confirm" */))
const _44888524 = () => interopDefault(import('../pages/teams/policies/privacy.vue' /* webpackChunkName: "pages/teams/policies/privacy" */))
const _46aff28c = () => interopDefault(import('../pages/teams/policies/refund.vue' /* webpackChunkName: "pages/teams/policies/refund" */))
const _77fbc9d1 = () => interopDefault(import('../pages/teams/policies/service.vue' /* webpackChunkName: "pages/teams/policies/service" */))
const _dba783da = () => interopDefault(import('../pages/order/product/_product.vue' /* webpackChunkName: "pages/order/product/_product" */))
const _1d531107 = () => interopDefault(import('../pages/orders/_order.vue' /* webpackChunkName: "pages/orders/_order" */))
const _13903db8 = () => interopDefault(import('../pages/s/_token.vue' /* webpackChunkName: "pages/s/_token" */))
const _1d526668 = () => interopDefault(import('../pages/takings/_id.vue' /* webpackChunkName: "pages/takings/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _6996f3db,
    name: "about___mo"
  }, {
    path: "/bindAccount",
    component: _687c1504,
    name: "bindAccount___mo"
  }, {
    path: "/consent",
    component: _3eb96730,
    name: "consent___mo"
  }, {
    path: "/coupons",
    component: _7061f04a,
    name: "coupons___mo"
  }, {
    path: "/game-ids",
    component: _44a0aa7f,
    name: "game-ids___mo"
  }, {
    path: "/hk",
    component: _ed6262c0,
    name: "index___hk"
  }, {
    path: "/me",
    component: _bc9e388c,
    name: "me___mo"
  }, {
    path: "/mp",
    component: _bb683376,
    name: "mp___mo"
  }, {
    path: "/order",
    component: _636d509f,
    name: "order___mo"
  }, {
    path: "/pay",
    component: _304b10f6,
    name: "pay___mo"
  }, {
    path: "/procedure",
    component: _62203521,
    name: "procedure___mo"
  }, {
    path: "/setting",
    component: _586d8f9e,
    name: "setting___mo"
  }, {
    path: "/takings",
    component: _423b6400,
    name: "takings___mo"
  }, {
    path: "/wx",
    component: _9865cefa,
    name: "wx___mo"
  }, {
    path: "/auth/binding",
    component: _16d6dfc0,
    name: "auth-binding___mo"
  }, {
    path: "/auth/forgot",
    component: _6ae2d2b8,
    name: "auth-forgot___mo"
  }, {
    path: "/auth/help",
    component: _2e7dfb16,
    name: "auth-help___mo"
  }, {
    path: "/auth/login",
    component: _1fda0938,
    name: "auth-login___mo"
  }, {
    path: "/auth/password",
    component: _1246fa20,
    name: "auth-password___mo"
  }, {
    path: "/auth/register",
    component: _6f45b2f8,
    name: "auth-register___mo"
  }, {
    path: "/hk/about",
    component: _6996f3db,
    name: "about___hk"
  }, {
    path: "/hk/bindAccount",
    component: _687c1504,
    name: "bindAccount___hk"
  }, {
    path: "/hk/consent",
    component: _3eb96730,
    name: "consent___hk"
  }, {
    path: "/hk/coupons",
    component: _7061f04a,
    name: "coupons___hk"
  }, {
    path: "/hk/game-ids",
    component: _44a0aa7f,
    name: "game-ids___hk"
  }, {
    path: "/hk/me",
    component: _bc9e388c,
    name: "me___hk"
  }, {
    path: "/hk/mp",
    component: _bb683376,
    name: "mp___hk"
  }, {
    path: "/hk/order",
    component: _636d509f,
    name: "order___hk"
  }, {
    path: "/hk/pay",
    component: _304b10f6,
    name: "pay___hk"
  }, {
    path: "/hk/procedure",
    component: _62203521,
    name: "procedure___hk"
  }, {
    path: "/hk/setting",
    component: _586d8f9e,
    name: "setting___hk"
  }, {
    path: "/hk/takings",
    component: _423b6400,
    name: "takings___hk"
  }, {
    path: "/hk/wx",
    component: _9865cefa,
    name: "wx___hk"
  }, {
    path: "/oauth/authorize",
    component: _024f8582,
    name: "oauth-authorize___mo"
  }, {
    path: "/order/cart",
    component: _58ed563a,
    name: "order-cart___mo"
  }, {
    path: "/order/checkout",
    component: _9701d2ee,
    name: "order-checkout___mo"
  }, {
    path: "/order/confirm",
    component: _40c3ae4d,
    name: "order-confirm___mo"
  }, {
    path: "/hk/auth/binding",
    component: _16d6dfc0,
    name: "auth-binding___hk"
  }, {
    path: "/hk/auth/forgot",
    component: _6ae2d2b8,
    name: "auth-forgot___hk"
  }, {
    path: "/hk/auth/help",
    component: _2e7dfb16,
    name: "auth-help___hk"
  }, {
    path: "/hk/auth/login",
    component: _1fda0938,
    name: "auth-login___hk"
  }, {
    path: "/hk/auth/password",
    component: _1246fa20,
    name: "auth-password___hk"
  }, {
    path: "/hk/auth/register",
    component: _6f45b2f8,
    name: "auth-register___hk"
  }, {
    path: "/hk/oauth/authorize",
    component: _024f8582,
    name: "oauth-authorize___hk"
  }, {
    path: "/hk/order/cart",
    component: _58ed563a,
    name: "order-cart___hk"
  }, {
    path: "/hk/order/checkout",
    component: _9701d2ee,
    name: "order-checkout___hk"
  }, {
    path: "/hk/order/confirm",
    component: _40c3ae4d,
    name: "order-confirm___hk"
  }, {
    path: "/teams/policies/privacy",
    component: _44888524,
    name: "teams-policies-privacy___mo"
  }, {
    path: "/teams/policies/refund",
    component: _46aff28c,
    name: "teams-policies-refund___mo"
  }, {
    path: "/teams/policies/service",
    component: _77fbc9d1,
    name: "teams-policies-service___mo"
  }, {
    path: "/hk/teams/policies/privacy",
    component: _44888524,
    name: "teams-policies-privacy___hk"
  }, {
    path: "/hk/teams/policies/refund",
    component: _46aff28c,
    name: "teams-policies-refund___hk"
  }, {
    path: "/hk/teams/policies/service",
    component: _77fbc9d1,
    name: "teams-policies-service___hk"
  }, {
    path: "/",
    component: _ed6262c0,
    name: "index___mo"
  }, {
    path: "/hk/order/product/:product?",
    component: _dba783da,
    name: "order-product-product___hk"
  }, {
    path: "/hk/orders/:order?",
    component: _1d531107,
    name: "orders-order___hk"
  }, {
    path: "/hk/s/:token?",
    component: _13903db8,
    name: "s-token___hk"
  }, {
    path: "/hk/takings/:id",
    component: _1d526668,
    name: "takings-id___hk"
  }, {
    path: "/order/product/:product?",
    component: _dba783da,
    name: "order-product-product___mo"
  }, {
    path: "/orders/:order?",
    component: _1d531107,
    name: "orders-order___mo"
  }, {
    path: "/s/:token?",
    component: _13903db8,
    name: "s-token___mo"
  }, {
    path: "/takings/:id",
    component: _1d526668,
    name: "takings-id___mo"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
